export default __webpack_public_path__ + "static/baselogo-be29ab6f8304a61dfc4bec9a8a12b892.png";